import { useLocation }  from "react-router-dom";
import Typography       from "@mui/material/Typography";
import FormLayout       from "ui/components/FormLayout";
import {
    EMAIL_SENT_HEADER,
    EMAIL_SENT_TEXT_1,
    EMAIL_SENT_TEXT_2,
    EMAIL_SENT_TEXT_3,
}                       from "config/config";

export default function EmailSent() {
    const loc = useLocation();
    return(
        <FormLayout>
            <Typography variant="h6">
                {EMAIL_SENT_HEADER}
            </Typography>
            <Typography align="center" color='secondary'>
                {EMAIL_SENT_TEXT_1}
                <Typography component='span' color='black'>
                    {(loc.state as {email: string}).email}
                </Typography>
                {EMAIL_SENT_TEXT_2}
            </Typography>
            <Typography align="center" color='secondary'>
                {EMAIL_SENT_TEXT_3}
            </Typography>
        </FormLayout>
    );
};